import { useContext } from "react";
import { IHeaderProps } from "./Header.interface";
import { AuthenticationContext } from "../../shared/providers/authentication/authentication.provider";
import ProfileCard from "../ProfileCard/ProfileCard";
import LanguagePicker from "../LanguagePicker/LanguangePicker";
import { useLocation } from "react-router-dom";
import { routes } from "../../shared/router/routes";
import { TranslationContext } from "../../shared/providers/translation/translation.provider";
import Link from "../Link/Link";
import Button from "../Button/Button";
import { LayoutContext } from "../../shared/providers/layout/layout.provider";
import ProfilePicture from "../ProfilePicture/ProfilePicture";

function Header(props: IHeaderProps) {
    const { translate } = useContext(TranslationContext);
    const { user } = useContext(AuthenticationContext);
    const { handleMenu, actions } = useContext(LayoutContext);
    const location = useLocation();

    return (
        <header
            ref={props.layoutRef}
            className="header pt-11 px-1 pb-12 px-md-31 pt-md-22 d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap">

            <div className="d-none d-md-block">{actions}</div>

            <div className="d-flex gap-1 align-items-center w-100">
                <Button
                    type="button"
                    customCss="menu is_solid bg-neutrals-white color-blue-500 d-md-none"
                    onClick={handleMenu}
                    iconSize={24}
                    icon="Menu"></Button>

                <div className="d-md-none">{actions}</div>
                <Link
                    customCss="favorite is_solid bg-neutrals-white color-blue-500 ms-auto"
                    to={routes.FAVORITES.path}
                    iconSize={32}
                    icon={
                        location.pathname.match(routes.FAVORITES.path)
                            ? "Favorite--filled"
                            : "Favorite"
                    }></Link>
                <LanguagePicker className="d-none d-md-flex" />
                <div className="d-md-none">
                    <Link customCss="p-0" to={routes.MY_ACCOUNT.path}>
                        <ProfilePicture />
                    </Link>
                </div>
                <div className="d-none d-md-block">
                    <ProfileCard />
                </div>
            </div>

            {location.pathname === routes.HOME.path && (
                <h1 className="text-h1-smbd w-100 d-md-none mt-22">
                    {translate("common.hello", "Hello")}, {user?.firstName ? `${user?.firstName} ${user?.lastName}` : user?.email}
                </h1>
            )}
        </header>
    );
}

export default Header;
